<template>
  <div id="coin" class="coin" :class="[side, { clicked }]" :title="t('flip')" @click="flip()">
    <div class="edge" />
    <div class="sides">
      <div class="shiny tails" v-text="t('tails')" />
      <div class="shiny heads" v-text="t('heads')" />
    </div>
  </div>
</template>

<script>
  import { ref } from 'vue'
  import { useI18n } from 'vue-i18n'

  export default {
    name: 'Coin',
    setup() {
      const clicked = ref(false)
      const side = ref('')

      function flip() {
        clicked.value = true
        side.value = ''

        setTimeout(() => {
          side.value = Math.random() < 0.5 ? 'heads' : 'tails'
        }, 50)
      }

      const { t } = useI18n({
        messages: {
          en: {
            flip: 'Flip the coin',
            tails: 'TAILS',
            heads: 'HEADS',
          },
          ru: {
            flip: 'Бросить монету',
            tails: 'ОРЁЛ',
            heads: 'РЕШКА',
          },
        },
      })

      return { flip, clicked, side, t }
    },
  }
</script>

<style>
  .coin {
    position: relative;
    width: 80px;
    height: 80px;
    font-size: 19px;
    font-weight: bold;
    color: #a80;
    perspective: 200px;
    cursor: pointer;
    animation: coin 2s infinite linear;
    user-select: none;
  }
  .coin:hover {
    filter: brightness(1.05);
  }
  .coin.clicked {
    animation: none;
  }
  .coin .edge {
    position: absolute;
    top: 0;
    left: 37px;
    width: 6px;
    height: 80px;
    background: #db0;
    border-radius: 3px/40px;
  }
  .coin .sides {
    position: absolute;
    width: 80px;
    height: 80px;
    transform-style: preserve-3d;
    transform: rotateY(-900deg);
  }
  .coin .heads,
  .coin .tails {
    position: absolute;
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    border: 5px solid #caa60b;
    border-radius: 40px;
    background: #fd0 url('../assets/coin.png') center center no-repeat;
    /*transition: all 4s cubic-bezier(0.175, 0.885, 0.32, 1.1);*/
    backface-visibility: hidden;
  }
  .coin .heads {
    transform: rotateY(180deg);
  }

  .coin.heads .sides {
    transform: rotateY(900deg);
    transition: all 4s cubic-bezier(0.175, 0.885, 0.32, 1.1);
  }
  .coin.tails .sides {
    transform: rotateY(720deg);
    transition: all 4s cubic-bezier(0.175, 0.885, 0.32, 1.1);
  }

  @keyframes coin {
    0% {
      transform: rotateZ(10deg);
    }
    50% {
      transform: rotateZ(-10deg);
    }
    100% {
      transform: rotateZ(10deg);
    }
  }
</style>
